var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Add } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FilterIcon } from "../../../assets/customIcons";
import { GridIcon, ListIcon } from "../../../builderPackage/assets/svg";
import { getUpdateKey } from "../../../builderPackage/common/commonFunctions";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import DashboardSearch from "../../../components/templates/search/dashboardSearch";
import { EModuleTypes, LOCAL_STORAGE_KEYS } from "../../../constants";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { setReducerState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { JcKey, ListViewTypes } from "../services/jcEntity";
import NewJobCardPaging from "./NewJobCardPaging";
import { FilterJobCard } from "./filterJobCard";
import { getJCListPage } from "../services/JobCardApiCall";
var NewJobCard = function () {
    var _getLocalStorageItem, _crud$JcKey$JcPaging;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var isTablet = useMediaQuery(function (theme) { return theme.breakpoints.between("sm", "md"); });
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var IdentityId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.IdentityId;
    var crud = useAppSelector(function (state) { return state.crud; });
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var filterValue = crud["filterValue"];
    console.log("filterValue", filterValue);
    var listVariants = [{
            Name: "My Job Card",
            id: IdentityId
        }, {
            Name: 'All Job Card',
            id: 'all'
        }];
    var handleOnClick = function () {
        navigate('/create-inspection');
    };
    var onFilterClick = function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Drawer',
                        Component: FilterJobCard,
                        componentProps: {
                            state: formValues
                        },
                        containerProps: {
                            anchor: IS_MOBILE ? 'bottom' : 'right',
                            PaperProps: {
                                sx: {
                                    width: {
                                        xs: '100%',
                                        sm: '400px'
                                    },
                                    borderRadius: {
                                        xs: '12px 12px 0 0',
                                        sm: 0
                                    }
                                }
                            }
                        }
                    }))];
                case 1:
                    res = _a.sent();
                    if (!(res !== null && res !== void 0 && res.payload)) {
                        return [2 /*return*/, {
                                disableChange: true
                            }];
                    }
                    return [2 /*return*/, res.payload];
            }
        });
    }); };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'page-header',
            columnSize: 12,
            px: {
                xs: 2,
                sm: 3
            },
            py: 2,
            spacing: 0,
            columnGap: 1,
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.SingleSelect,
                    name: 'IdentityId',
                    value: !isAllViewActive ? listVariants[0].id : listVariants[1].id,
                    options: listVariants,
                    valueExpr: 'id',
                    displayExpr: 'Name',
                    size: 'medium',
                    columnSize: 0,
                    disableUnderline: true,
                    variant: 'standard',
                    sx: {
                        fontWeight: 'strong',
                        fontSize: {
                            xs: 'lg',
                            sm: 'xxl'
                        }
                    },
                    SelectDisplayProps: {
                        style: {
                            fontSize: 'inherit',
                            lineHeight: 'inherit',
                            paddingBottom: 0,
                            paddingTop: 0
                        }
                    },
                    setFormState: function (formValues, currValue, field) {
                        dispatch(setReducerState({
                            key: "filterValue",
                            value: null
                        }));
                        return {};
                    }
                }, {
                    type: FormItemTypes.Chip,
                    name: '',
                    color: 'info',
                    value: ((_crud$JcKey$JcPaging = crud[JcKey.JcPaging]) === null || _crud$JcKey$JcPaging === void 0 ? void 0 : _crud$JcKey$JcPaging.TotalCount) || 0,
                    columnSize: 0,
                    size: 'small'
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'action-panel',
            px: {
                xs: 2,
                sm: 3
            },
            py: 2,
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'space-between',
            alignItems: 'center',
            spacing: 0,
            columnSpacing: 1,
            elements: [{
                    type: FormItemTypes.Custom,
                    name: 'search-jobcard',
                    columnSize: true,
                    element: function (_ref) {
                        var _value$Status, _value$ProductId;
                        var value = _ref.value;
                        return /*#__PURE__*/ React.createElement(DashboardSearch, {
                            moduleName: EModuleTypes.Jobcard,
                            request: {
                                FromDate: value === null || value === void 0 ? void 0 : value.FromDate,
                                ToDate: value === null || value === void 0 ? void 0 : value.ToDate,
                                Status: value === null || value === void 0 || (_value$Status = value.Status) === null || _value$Status === void 0 ? void 0 : _value$Status.map(function (item) {
                                    return item.Key;
                                }),
                                ServiceTypeId: value === null || value === void 0 ? void 0 : value.RepairTypeId,
                                ModelId: (_value$ProductId = value === null || value === void 0 ? void 0 : value.ProductId) !== null && _value$ProductId !== void 0 ? _value$ProductId : undefined,
                                BranchId: value === null || value === void 0 ? void 0 : value.BranchId
                            }
                        });
                    },
                    containerProps: {
                        maxWidth: {
                            sm: 400,
                            md: 400
                        }
                    }
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: 0,
                    gap: {
                        xs: 0,
                        sm: 1.5
                    },
                    alignItems: 'center',
                    elements: [!IS_MOBILE ? {
                            type: FormItemTypes.CardComponent,
                            name: 'View',
                            value: ListViewTypes.List,
                            columnSize: 0,
                            sx: {
                                p: {
                                    sm: 0.5
                                },
                                bgcolor: 'secondary.100',
                                borderColor: 'secondary.200'
                            },
                            contentProps: {
                                spacing: 0,
                                flexWrap: 'nowrap',
                                columnGap: 0.5
                            },
                            elements: [{
                                    type: FormItemTypes.Button,
                                    name: ListViewTypes.List,
                                    columnSize: 0,
                                    color: 'secondary',
                                    size: 'icon',
                                    children: /*#__PURE__*/ React.createElement(ListIcon, null),
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    View: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.View) === this.name ? 'outlined' : 'text',
                                            sx: {
                                                color: (state === null || state === void 0 ? void 0 : state.View) === this.name ? 'text.primary' : undefined
                                            }
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: ListViewTypes.Card,
                                    columnSize: 0,
                                    color: 'secondary',
                                    size: 'icon',
                                    children: /*#__PURE__*/ React.createElement(GridIcon, null),
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    View: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.View) === this.name ? 'outlined' : 'text',
                                            sx: {
                                                color: (state === null || state === void 0 ? void 0 : state.View) === this.name ? 'text.primary' : undefined
                                            }
                                        };
                                    }
                                }]
                        } : null, !(IS_MOBILE || isTablet) ? {
                            type: FormItemTypes.Button,
                            name: '',
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            id: 'filter-icon',
                            children: "Filters",
                            startIcon: /*#__PURE__*/ React.createElement(FilterIcon, null),
                            setFormState: onFilterClick
                        } : {
                            type: FormItemTypes.Button,
                            name: '',
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            id: 'filter-icon',
                            size: 'icon',
                            children: /*#__PURE__*/ React.createElement(FilterIcon, null),
                            setFormState: onFilterClick
                        }, {
                            type: FormItemTypes.Button,
                            name: 'NewJobCardButton',
                            children: 'New',
                            color: 'primary',
                            variant: 'contained',
                            startIcon: /*#__PURE__*/ React.createElement(Add, null),
                            onClick: handleOnClick,
                            columnSize: 0,
                            hidden: IS_MOBILE
                        }]
                }]
        }, {
            type: FormItemTypes.Custom,
            name: 'DynamicCatalogBuilder',
            columnSize: 12,
            element: NewJobCardPaging
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'bottom-fixed-button',
            position: 'fixed',
            bottom: 0,
            px: {
                xs: 2,
                sm: 3
            },
            py: 2,
            spacing: 0,
            columnSize: 12,
            hidden: !IS_MOBILE,
            borderTop: '1px solid',
            borderColor: 'secondary.200',
            bgcolor: 'background.secondary',
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'NewJobCardButton',
                    variant: 'contained',
                    color: 'primary',
                    columnSize: 12,
                    children: 'New',
                    size: 'small',
                    startIcon: /*#__PURE__*/ React.createElement(Add, null),
                    fullWidth: true,
                    onClick: handleOnClick
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isDesktop && /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData,
        onChange: function (e, _ref2) {
            var state = _ref2.state, field = _ref2.field;
            if (state !== null && state !== void 0 && state.disableChange) {
                return {
                    disableChange: false
                };
            }
            if (e && field)
                dispatch(setReducerState({
                    key: getUpdateKey(JcKey.JcPaging),
                    value: true
                }));
        },
        gridProps: {
            spacing: 0
        },
        getFormAPI: getJCListPage,
        getRequest: {
            IdentityId: !isAllViewActive ? listVariants[0].id : listVariants[1].id,
            View: IS_MOBILE ? ListViewTypes.Card : ListViewTypes.List,
            Status: filterValue === null || filterValue === void 0 ? void 0 : filterValue.Status,
            FromDate: filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate,
            ToDate: filterValue === null || filterValue === void 0 ? void 0 : filterValue.EndDocDate,
            paging: true
        }
    }));
};
export default NewJobCard;
